module.exports = __webpack_public_path__ + "static/timmayanorange-9550b4143b0e281349e538ef5c9409c1.jpg";